import { render, staticRenderFns } from "./FormFpostgradedit.vue?vue&type=template&id=6628b541&"
import script from "./FormFpostgradedit.vue?vue&type=script&lang=js&"
export * from "./FormFpostgradedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports